<template>
    <div class="item-bg">
        <a-row v-if="isPc" type="flex" justify="space-between">
            <a-col span="14">
                <a-form-model layout="vertical" ref="ruleForm" :form="menu" :rules="rules" :model="menu">
                    <a-form-model-item has-feedback :label="$t('edit.menu') + menu.num + $t('edit.name')">
                        <a-input :value="menu.title"
                                 :placeholder="$t('edit.input.menuHolder')+(item.num)+$t('edit.name')"
                                 @input="onChangeName"/>
                    </a-form-model-item>
                    <a-form-model-item has-feedback :label="$t('edit.menu') + menu.num + $t('edit.type')">
                        <a-select
                                :placeholder="$t('edit.input.typeHolder')+(menu.num)+$t('edit.type')"
                                @change="handleChangeSelect"
                                v-if="menu.id"
                                :value="~~menu.type"
                        >
                            <a-select-option
                                    :value="item.value"
                                    v-for="item in selectOptions"
                                    :key="item.num"
                                    :disabled="item.disabled"
                            >{{item.title}}
                            </a-select-option>
                        </a-select>
                        <a-select :placeholder="$t('edit.input.typeHolder')+(item.num)+$t('edit.type')"
                                  @change="handleChangeSelect" v-else>
                            <a-select-option
                                    :value="item.value"
                                    v-for="item in selectOptions"
                                    :key="item.num"
                                    :disabled="item.disabled"
                            >{{item.title}}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <!--網址-->
                    <a-form-model-item has-feedback :label="$t('edit.site')" v-if="menu.type==1">
                        <a-input :value="menu.content" @input="changeContent" :placeholder="$t('edit.site')"/>
                    </a-form-model-item>
                    <!--電話號碼-->
                    <a-form-model-item has-feedback :label="$t('edit.phoneNo')" v-if="menu.type==2">
                        <a-input
                            :value="menu.content"
                            @input="changeContent"
                            :placeholder="$t('edit.phoneNo')"
                        />
                    </a-form-model-item>
                    <!--地圖-->
                    <a-form-model-item has-feedback :label="$t('edit.address')" v-if="menu.type==3">
                        <a-input
                            :value="menu.content"
                            @input="changeContent"
                            :placeholder="$t('edit.address')"
                        />
                        <!-- <marker-map-google
                            @changeLocation="changeLocation"
                            :location="menu.content.address?menu.content.latLng:{}"
                            v-if="menu.id"
                            :map-id="menu.id.toString()"
                        ></marker-map-google>
                        <marker-map-google 
                            v-else 
                            @changeLocation="changeLocation" 
                            :map-id="'map_contanier'+getTime"
                        ></marker-map-google> -->
                    </a-form-model-item>
                    <!--圖文-->
                    <a-form-model-item :label="$t('edit.companyInfo')" v-if="menu.type==4">
                        <editor :value="menu.content" @changeEditor="changeEditor" style="height: 500px"></editor>
                    </a-form-model-item>
                    <!--視頻-->
                    <div v-if="menu.type==5">
                        <p style="color:#fff">{{$t('edit.videoDetail')}}：</p>
                        <a-row>
                            <!--              <video :src="menu.content.url" controls="controls" width="100%" height="400px"></video>-->
                            <video-player
                                    class="video-player vjs-custom-skin"
                                    ref="videoPlayer"
                                    :options="videoPlayerOptions"
                                    :playsinline="true"
                            ></video-player>
                        </a-row>
                        <p v-if="menu.content.name" style="color:#fff">{{menu.content.name}}</p>
                        <material-select :type="3" @selected="handleSelectedVideo"/>
                    </div>
                    <!-- <div class="video-content" v-if="menu.type==5">
                      <div>{{$t('edit.videoDetail')}}</div>
                      <div style="margin: 20px">
                        <a-upload
                          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                          list-type="picture"
                          :default-file-list="fileList"
                          class="upload-list-inline"
                        >
                          <a-button>
                            <a-icon type="upload" />選擇視頻
                          </a-button>
                        </a-upload>
                      </div>
                    </div>-->
                </a-form-model>
            </a-col>
            <a-col span="6">
                <div class="right-box" :class="isBackstage?'backstage-box':''">
                    <a-button type="danger" ghost @click="deleteItem" v-if="isEdit">
                        <a-icon type="delete"></a-icon>
                        {{$t('actionTitles.delete')}}
                    </a-button>
                    <div v-if="isBackstage" class="is-edit-box">
                        <a-checkbox
                                @change="onChange"
                                :checked="Boolean(menu.is_edit)"
                        ></a-checkbox>
                        <span class="item-permission">{{$t('actionTitles.enableModify')}}</span>
                    </div>
                </div>

            </a-col>
        </a-row>
        <a-row v-else>
            <a-col>
                <a-form-model layout="vertical" ref="ruleForm" :form="menu" :rules="rules" :model="menu">
                    <a-form-model-item has-feedback :label="$t('edit.menu') + menu.num + $t('edit.name')">
                        <a-input :value="menu.title" @input="onChangeName"
                                 :placeholder="$t('edit.input.menuHolder')+(item.num)+$t('edit.name')"/>
                    </a-form-model-item>

                    <a-form-model-item has-feedback :label="$t('edit.menu') + menu.num + $t('edit.type')">
                        <a-select
                                :placeholder="$t('edit.input.typeHolder')+(menu.num)+$t('edit.type')"
                                @change="handleChangeSelect"
                                v-if="menu.id"
                                :value="~~menu.type"
                        >
                            <a-select-option
                                    :value="item.value"
                                    v-for="item in selectOptions"
                                    :key="item.num"
                                    :disabled="item.disabled"
                            >{{item.title}}
                            </a-select-option>
                        </a-select>
                        <a-select :placeholder="$t('edit.input.typeHolder')+(item.num)+$t('edit.type')"
                                  @change="handleChangeSelect" v-else>
                            <a-select-option
                                    :value="item.value"
                                    v-for="item in selectOptions"
                                    :key="item.num"
                                    :disabled="item.disabled"
                            >{{item.title}}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <!--網址-->
                    <a-form-model-item has-feedback :label="$t('edit.site')" v-if="menu.type==1">
                        <a-input :value="menu.content" @input="changeContent" :placeholder="$t('edit.site')"/>
                    </a-form-model-item>
                    <!--電話號碼-->
                    <a-form-model-item has-feedback :label="$t('edit.phoneNo')" v-if="menu.type==2">
                        <a-input
                                :value="menu.content"
                                @input="changeContent"
                                :placeholder="$t('edit.phoneNo')"
                        />
                    </a-form-model-item>

                    <!--地圖-->
                    <a-form-model-item has-feedback :label="$t('edit.address')" v-if="menu.type==3">
                        <a-input
                            :value="menu.content"
                            @input="changeContent"
                            :placeholder="$t('edit.address')"
                        />
                        <!-- <marker-map-google
                            @changeLocation="changeLocation"
                            :location="menu.content.address?menu.content.latLng:{}"
                            v-if="menu.id"
                            :map-id="menu.id.toString()"
                        ></marker-map-google>
                        <marker-map-google 
                            v-else 
                            @changeLocation="changeLocation" 
                            :map-id="'map_contanier'+getTime"
                        ></marker-map-google> -->
                    </a-form-model-item>
                    <!--圖文-->
                    <a-form-model-item :label="$t('edit.companyInfo')" v-if="menu.type==4">
                        <editor :value="menu.content" @changeEditor="changeEditor" style="height: 500px"></editor>
                    </a-form-model-item>
                    <!--視頻-->
                    <a-row v-if="menu.type==5">
                        <p style="color:#fff">{{$t('edit.videoDetail')}}：</p>
                        <div>
                            <!--              <video :src="menu.content.url" controls="controls" width="100%" height="230px"></video>-->
                            <video-player
                                    class="video-player vjs-custom-skin"
                                    style="margin-bottom:10px"
                                    ref="videoPlayer"
                                    :options="videoPlayerOptions"
                                    :playsinline="true"
                            ></video-player>
                        </div>
                        <p v-if="menu.content.name" style="color:#fff">{{menu.content.name}}</p>
                        <material-select :type="3" @selected="handleSelectedVideo"/>
                    </a-row>
                    <a-row style="margin: 20px 0">
                        <a-button type="danger" ghost @click="deleteItem" v-if="isEdit">
                            <a-icon type="delete"></a-icon>
                            {{$t('actionTitles.delete')}}
                        </a-button>
                    </a-row>
                    <!-- <div class="video-content" v-if="menu.type==5">
                      <div>{{$t('edit.videoDetail')}}</div>
                      <div style="margin: 20px">
                        <a-upload
                          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                          list-type="picture"
                          :default-file-list="fileList"
                          class="upload-list-inline"
                        >
                          <a-button>
                            <a-icon type="upload" />選擇視頻
                          </a-button>
                        </a-upload>
                      </div>
                    </div>-->
                </a-form-model>
            </a-col>
        </a-row>
        <div class="stop-cover" v-if="!isEdit" @click.stop></div>
        <div class="hr" v-if="isPc" :class="isBackstage?'backstage-hr':''"></div>
    </div>
</template>

<script>
    import Editor from "@/components/Editor";
    // import MarkerMap from "@/components/MarkerMap";
    // import MarkerMapGoogle from "@/components/MarkerMapGoogle";
    import MaterialSelect from "@/components/MaterialSelect";
    import {mapGetters} from "vuex";

    export default {
        components: {
            Editor, 
            // MarkerMapGoogle, 
            MaterialSelect
        },
        props: {
            isBackstage: {
                default: false,
                type: Boolean,
            },
            selectOptions: {
                type: Array,
                require: true,
            },
            item: {
                type: Object,
                require: true,
            },
            isPc: {
                default: true,
                type: Boolean,
            },
        },
        watch: {
            item(value) {
                this.menu = value;
                if (this.menu.type == 5) {
                    this.videoPlayerOptions['sources'][0]['src'] = this.menu.content.url
                }
            }
        },
        computed: {
            ...mapGetters(["userConfig"]),
            isEdit() {
                if (this.userConfig) {
                    const configMenus = this.userConfig.menus;
                    let isEdit = true;
                    if (configMenus && configMenus.length) {
                        const menu = configMenus.find(element => +element.id === +this.item.mid);
                        if (menu) {
                            isEdit = +menu.is_edit === 1
                        }
                    }
                    return isEdit;
                } else {
                    return true;
                }
            },
            getTime(){
                return new Date().getTime()
            }
        },
        data() {
            return {
                menu: {},
                rules: {},
                fileList: [],
                videoList: [],
                videoPlayerOptions: {
                    playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                    autoplay: false, //如果true,瀏覽器準備好時開始回放。
                    muted: false, // 默認情況下將會消除任何音頻。
                    loop: false, // 導致視頻一結束就重新開始。
                    preload: "auto", // 建議瀏覽器在<video>加載元素後是否應該開始下載視頻數據。auto瀏覽器選擇最佳行為,立即開始加載視頻（如果瀏覽器支持）
                    language: "zh-CN",
                    aspectRatio: "16:9", // 將播放器置於流暢模式，並在計算播放器的動態大小時使用該值。值應該代表一個比例 - 用冒號分隔的兩個數字（例如"16:9"或"4:3"）
                    fluid: true, // 當true時，Video.js player將擁有流體大小。換句話說，它將按比例縮放以適應其容器。
                    sources: [
                        {
                            type: "", //這裡的種類支持很多種：基本視頻格式、直播、流媒體等，具體可以參看git網址項目
                            src: "", //url地址
                        },
                    ],
                    notSupportedMessage: this.$t('tour.message.videoMsg'), //允許覆蓋Video.js無法播放媒體源時顯示的默認信息。
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        fullscreenToggle: true, //全屏按鈕
                    },
                }
            };
        },
        mounted() {
            this.menu = this.item;
            if (this.menu.type == 5) {
                this.videoPlayerOptions['sources'][0]['src'] = this.menu.content.url
            }
        },
        methods: {
            getcurrTime() {
                return new Date().getTime()
            },
            handleChangeSelect(value) {
                this.menu = {...this.menu, type: value, content: ""};
                this.$emit("changSource", this.menu);
            },
            deleteItem() {
                this.$emit("del", this.menu.num);
            },
            onChange(e) {
                this.menu.is_edit = Number(e.target.checked);
                this.$emit("changSource", this.menu);
            },
            changeLocation(resultInfo) {
                this.menu.content = resultInfo;
                this.$emit("changSource", this.menu);
            },
            //<!--圖文-->
            // onEditorBlur(quill) {
            //   console.log("editor blur!", quill);
            // },
            // onEditorFocus(quill) {
            //   console.log("editor focus!", quill);
            // },
            // onEditorReady(quill) {
            //   console.log("editor ready!", quill);
            // },
            // onEditorChange({ quill, html, text }) {
            //   console.log("editor change!", quill, html, text);
            //   this.content = html;
            // },
            onChangeName(e) {
                this.menu.title = e.target.value
                console.log("====", e.target.value)
                this.$emit("changSource", this.menu);
            },
            changeEditor(content) {
                this.menu.content = content;
                this.$emit("changSource", this.menu);
            },
            handleSelectedVideo(item) {
                this.menu.content = {};
                this.menu.content.name = item.name;
                this.menu.content.url = item.url;
                this.videoPlayerOptions['sources'][0]['src'] = this.menu.content.url
                this.$emit("changSource", this.menu);
            },
            changeContent(e) {
                this.menu.content = e.target.value;
                this.$emit("changSource", this.menu);
            },

        },
    };
</script>

<style lang="less" scoped>
    .item-bg {
        /*border-bottom: 1px solid #555;*/
        padding: 30px 0;
        position: relative;
    }

    .stop-cover {
        position: absolute;
        top: 0;
        bottom: 0;
        right: -10px;
        left: -10px;
        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        z-index: 2;
    }

    .hr {
        width: 100%;
        height: 2px;
        border-top: 1px solid rgb(0, 0, 0);
        border-bottom: 1px solid rgb(75, 75, 75);
        margin: 30px 0 0 0;
        &.backstage-hr{
            height: 1px;
            border: 0;
            background-color: #dddddd;
        }
    }

    ::v-deep .ql-editor {
        color: #000;
    }
    .right-box{
        display: flex;
        height: 100%;
        flex-wrap: wrap;
        position: relative;
        &.backstage-box{
            justify-content: flex-end;
        }
        .is-edit-box{
            position: absolute;
            bottom: 0;
            right: 0;
            z-index: 10;
        }
    }
</style>
